import { gql } from '@apollo/client';
import { PickupAppointmentType } from './getPickupAppointmentListing';

export const GET_PICKUP_APPOINTMENTS_BY_ID_LIST = gql`
  query GetPickupAppointmentsByIdList($appointmentIds: [Long!]!) {
    pickupAppointments: getPickupAppointmentsByIdList(appointmentIds: $appointmentIds) {
      id
      appointmentNumber
      channelId
      channelName
      warehouseId
      warehouseName
      cooperationWarehouseId
      cooperationWarehouseName
      addressLine1
      addressLine2
      city
      state
      zipcode
      country
      timezone
      expectedPickupDate
      expectedPickupTimeStart
      expectedPickupTimeEnd
      expectedParcelCount
      expectedParcelUnit
      actualParcelCount
      actualParcelUnit
      notes
      status
      taskNumber
      trackingNumbersJson
    }
  }
`;

export interface GetPickupAppointmentsByIdListResponse {
  pickupAppointments: PickupAppointmentType[];
} 